var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "d-flex filters" };
import { onMounted, ref } from 'vue';
import RecruitEtcFilter from './RecruitEtcFilter.vue';
import ApiService from '@/ts/core/services/ApiService';
export default /*@__PURE__*/ _defineComponent(__assign({
    name: 'recruit-filters',
}, { __name: 'RecruitEtcFilters', props: {
        titles: {
            required: true,
            type: Object
        },
        requestEtcCodes: {
            required: false,
            default: [],
            type: Array
        },
        requestEtcCategories: {
            required: false,
            default: [],
            type: Array
        },
        filterVisible: {
            type: Boolean,
            required: true
        },
    }, emits: ['toggle'], setup: function (__props, _a) {
        var _this = this;
        var __emit = _a.emit;
        var props = __props;
        var emits = __emit;
        var locales = ref({});
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiService.get(process.env.MIX_API_HOST + '/trans/service')];
                    case 1:
                        request = _a.sent();
                        if (request.data) {
                            locales.value = request.data.data;
                        }
                        return [2 /*return*/];
                }
            });
        }); });
        var handleChildToggle = function (targetType) {
            emits('toggle', targetType);
        };
        var closeFilter = function () {
            if (props.filterVisible) {
                emits('toggle', props.filterVisible);
            }
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _withDirectives(_createElementVNode("div", {
                    class: "filter-backdrop",
                    onClick: closeFilter
                }, null, 512), [
                    [_vShow, __props.filterVisible]
                ]),
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(RecruitEtcFilter, {
                        class: "etc",
                        ref: "etcRef",
                        titles: __props.titles,
                        "request-codes": __props.requestEtcCodes,
                        "request-categories": __props.requestEtcCategories,
                        locales: locales.value,
                        "filter-visible": __props.filterVisible,
                        onFilterToggleEvent: handleChildToggle
                    }, null, 8, ["titles", "request-codes", "request-categories", "locales", "filter-visible"])
                ])
            ], 64));
        };
    } }));
